<div class="c-text-strike-through">
  @if (!!label) {
    <span class="c-text-strike-through__label">{{ label }}</span>
  }
</div>
